import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { apiUrl } from "../constants";

export const AuthContext = createContext({});

function AuthContextProvider({ children }) {
  let navigate = useNavigate();
  const [authState, setAuthState] = useState({
    user: null,
    status: "pending",
  });

  // Here we fetch the user data if we have a token.
  async function fetchUserData(jwtToken) {
    try {
      const result = await axios.get(`${apiUrl}/auth/user`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      setAuthState({
        user: {
          role: result.data.user.role,
        },
        status: "done",
      });
    } catch (e) {
      console.error(e);
    }
  }

  // When the page is loaded we get the token from the localStorage and check if it is valid if not then we set the user to null otherwise we activate the fetchUserData function.
  useEffect(() => {
    const token = localStorage.getItem("token");
    const now = new Date();
    const epochTimeNow = now.getTime();

    if (token !== null && authState.user === null) {
      const decoded = jwt_decode(token);
      const iat = new Date(decoded.iat * 1000);
      const tokenExpires = iat.getTime() + 9 * (60 * 60 * 1000);
      if (epochTimeNow < tokenExpires) {
        fetchUserData(token);
      } else if (epochTimeNow >= tokenExpires) {
        localStorage.clear();
        setAuthState({
          user: null,
          status: "done",
        });
      }
    } else {
      setAuthState({
        user: null,
        status: "done",
      });
    }
  }, []);

  // We set the token en activate the fetchUserData function.
  async function login(jwtToken) {
    localStorage.setItem("token", jwtToken);
    await fetchUserData(jwtToken);
  }

  // Her we set the user to null and navigate the user to the home page.
  function signOut() {
    localStorage.clear();
    setAuthState({
      user: null,
      status: "done",
    });

    navigate("/signingin");
  }

  // Here we make an object to be handled in the AuthContext.Provider
  const data = {
    ...authState,
    login: login,
    signOut: signOut,
  };

  return (
    <>
      <AuthContext.Provider value={data}>
        {authState.status === "done" ? children : <p>Loading...</p>}
      </AuthContext.Provider>
    </>
  );
}

export default AuthContextProvider;
